import React from 'react';
import { Link } from 'react-router-dom';

import { Padding } from '../../components/common/atom/Padding';
import FriendPaybackList from './FriendPaybackList';

import { EVENT_DETAIL } from '../../lib/routes/path';
import { EVENT_DETAIL_PC_FRIEND } from '../../lib/image/event/EventFriendImages';
import { Image } from '../../components/common/atom/Image';
import WithLoading from '../../Hoc/WithLoading';

const FriendPayback = () => {
  return (
    <>
      <WithLoading component={FriendPaybackList} url={'/payback/list/'} />
      <FriendPaybackBanner />
    </>
  );
};

export default FriendPayback;

export const FriendPaybackBanner = () => (
  <Padding top={20} bottom={30}>
    <Link to={`${EVENT_DETAIL}/friend`}>
      <Image src={EVENT_DETAIL_PC_FRIEND} />
    </Link>
  </Padding>
);
